import { useState, useEffect } from 'react';
import { Animated } from 'react-animated-css';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    div: {
      borderStyle: 'groove',
    },
    wrapper: {
      position: 'relative',
      zIndex: 5,
    },
  })
);

interface SnapshotProps {
  source?: string;
  onVisible?: (visible: boolean) => void;
}

const Snapshot = ({ source, onVisible }: SnapshotProps) => {
  const classes = useStyles();

  const [visible, setVisible] = useState(false);
  const [imgSrc, setImgSrc] = useState('');
  const [imgW, setImgW] = useState(640);
  const [imgH, setImgH] = useState(360);

  const setVisibleX = (visible: boolean) => {
    setVisible(visible);
    if (onVisible) {
      onVisible(visible);
    }
  };

  useEffect(() => {
    if (source.length <= 0) {
      return;
    }
    setVisibleX(true);
    setImgSrc(source);
    setTimeout(() => {
      setVisibleX(false);
    }, 1200);
  }, [source]);

  return imgSrc.length > 0 ? (
    <Animated
      animationIn="fadeInRightBig"
      animationOut="zoomOutLeft"
      animationInDuration={800}
      animationOutDuration={800}
      isVisible={visible}
      className={classes.wrapper}
    >
      <div className={classes.div}>
        <img
          src={imgSrc}
          style={{ width: imgW, height: imgH, objectFit: 'fill' }}
          onLoad={(evt: any) => {
            if (evt && evt.target && evt.target.naturalWidth && evt.target.naturalHeight) {
              setImgW(evt.target.naturalWidth * 0.5);
              setImgH(evt.target.naturalHeight * 0.5);
            }
          }}
        />
      </div>
    </Animated>
  ) : (
    <></>
  );
};

export default Snapshot;
